<template>
    <div class="class-index">
        <div class="container-fluid mt-1">
            <div class="row">
                <div class="col-xl-8 mb-5 mb-xl-0">
                    <div class="card">
                        <div class="card-header">
                            <div class="col">
                                <h6 class="text-uppercase ls-1 mb-1">Daftar Kelas</h6>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="table-class-list px-2">
                                <table class="table table-striped">
                                    <tr v-for="(item, index) in classList" :key="index">
                                        <td style="width: 100%;" class="class-list">
                                            <h6 class="text-uppercase ls-1 mb-1 line-with-icon">
                                                <router-link :to="{ name: 'class-detail', params: { classId: item.id }}">{{item.name}}</router-link>
                                            </h6>
                                        </td>
                                        <td>
                                            <b-dropdown id="class-list-action" right text="AKSI" size="sm" class="m-md-2">
                                                <b-dropdown-item @click="outOfClass(item.id)"><i class="fa fa-trash" aria-hidden="true"></i>Hapus Kelas</b-dropdown-item>
                                            </b-dropdown> 
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4">
                    <div class="card">
                        <div class="card-header">
                            <div class="col">
                                <h6 class="text-uppercase ls-1 mb-1">Info</h6>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="identity px-2">
                                <p class="line-with-icon"><i class="clr-red fa fa-user" aria-hidden="true"></i>{{user.full_name}}</p>
                                <p class="line-with-icon"><i class="clr-red fa fa-user" aria-hidden="true"></i>{{user.type}}</p>
                                <p class="line-with-icon"><i class="clr-red fa fa-envelope" aria-hidden="true"></i>{{user.email}}</p>
                            </div>
                            <hr>
                            <div class="card class-followed text-center">
                                <div class="card-header font-weight-bold">
                                    Mengampu
                                </div>
                                <div class="card-body">
                                    <h6>{{overview.total_class}}</h6>
                                    <p>KELAS</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <card header-classes="bg-transparent" class="mt-4">
                        <div slot="header" class="row align-items-center">
                            <div class="d-flex justify-content-between" style="align-items: center;">
                                <div>
                                    <h6 class="text-uppercase ls-1 mb-1">DAFTAR KELAS</h6>
                                </div>
                                <div>
                                    <b-dropdown id="dropdown-1" right text="AKSI" size="sm" class="m-md-2">
                                        <b-dropdown-item v-if="user.type == 'tutor' || user.type == 'admin'" @click="showAddClassModal"><i class="fa fa-plus-circle" aria-hidden="true"></i>Tambah Kelas</b-dropdown-item>
                                        <b-dropdown-item v-if="user.type == 'tutor' || user.type == 'admin'">
                                            <i class="fa fa-cogs" aria-hidden="true"></i>
                                            <router-link :to="{ name: 'class-list'}" class="text-black">Kelola Kelas</router-link>
                                        </b-dropdown-item>
                                        <b-dropdown-item @click="showJoinClassModal"><i class="fa fa-user-plus" aria-hidden="true"></i>Gabung Kelas</b-dropdown-item>
                                    </b-dropdown>   
                                </div>
                            </div>
                        </div>
                        <div class="class-list px-2">
                            <p v-for="(item, index) in classList" :key="index" class="line-with-icon">
                                <i class="fa fa-folder clr-red" aria-hidden="true"></i>
                                <router-link :to="{ name: 'class-detail', params: { classId: item.id }}">{{item.name}}</router-link>
                                <br>
                                <sup><b>-- {{item.status}} --</b></sup>
                            </p>
                        </div>
                    </card>
                </div>
            </div>
        </div>
		<b-modal
			ref="new-class-modal"
			class="new-class-modal"
			size="md"
            title="Tambah Kelas Baru"
            @show="resetNewClassModal"
            @hidden="resetNewClassModal"
			hide-footer
			no-close-on-backdrop
		>
            <div class="new-class-body">
                <b-form data-vv-scope="new-class-form">
                    <b-row class="kelas">
                        <b-col sm="3">
                            <label for="input-nama-kelas">Nama Kelas</label>
                        </b-col>
                        <b-col sm="9">
                            <b-form-input
                            id="input-nama-kelas"
                            name="class_name"
                            data-vv-as="Nama kelas"
                            v-model="add_class_form.name"
                            type="text"
                            placeholder="Nama Kelas Baru"
                            v-validate="'required'"
                            autocomplete="off"
                            ></b-form-input>
                            <span :class="{ 'error-validation': errors.first('new-class-form.class_name') }">{{ errors.first('new-class-form.class_name') }}</span>
                        </b-col>
                    </b-row>
                </b-form>
            </div>
            <hr>
            <div class="new-class-footer d-flex justify-content-end">
                <b-button variant="outline-danger" size="md" style="width: 25%;" @click="hideAddClassModal">BATAL</b-button>
                <b-button variant="primary" size="md" style="width: 25%;" @click.prevent="saveNewClass">SIMPAN</b-button>
            </div>
		</b-modal>
		<b-modal
			ref="join-class-modal"
			class="join-class-modal"
			size="md"
            title="Bergabung Kelas"
            @show="resetJoinClassModal"
            @hidden="resetJoinClassModal"
			hide-footer
			no-close-on-backdrop
		>
            <join-class-form></join-class-form>
		</b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { EventBus } from '@/eventBus.js'
	import JoinClassForm from "../../../components/Main/JoinClassForm";
    export default {
        components: {
            JoinClassForm
        },
        data() {
            return {
                add_class_form: {
                    name: null
                }
            }
        },
        computed: {
            ...mapGetters({
                user: 'getUser',
                classList: 'getClassList',
                overview: 'getOverview',
                isAdmin: 'isAdmin',
                isTutor: 'isTutor',
            })
        },
        methods: {
            showAddClassModal() {
                this.$refs['new-class-modal'].show()
            },
            hideAddClassModal() {
                this.$refs['new-class-modal'].hide()
                this.resetNewClassModal()
            },
            showJoinClassModal() {
                this.$refs['join-class-modal'].show()
            },
            hideJoinClassModal() {
                this.$refs['join-class-modal'].hide()
                this.resetJoinClassModal()
            },
            resetJoinClassModal() {
                EventBus.$emit('resetJoinClassForm', true)
            },
            resetNewClassModal() {
                this.add_class_form.name = null
                this.$validator.reset()
            },
            async saveNewClass() {
                // this.showLoader = true
                let scope = 'new-class-form'
                this.$validator.validateAll(scope).then(valid => {
                    if (valid) {
                        let name = this.add_class_form.name 
						this.$store.dispatch('addClass', { name })
							.then((res) => {
								// this.showLoader = false
                                this.getClassList()
                                this.getOverview()
                                this.hideAddClassModal()
                                this.$swal.fire('Success', res.message, 'success')
							})
							.catch((err)=> {
								// this.showLoader = false
                                this.$swal.fire('Failed', err.response.data.message, 'error')
							})
                    }
                });
            },
			async getClassList() {
				await this.$store.dispatch('getClassList')
					.then(() => {
					})
					.catch((err)=> {
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
            async getOverview() {
				await this.$store.dispatch('getOverview')
					.then(() => {
					})
					.catch((err)=> {
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
            async deleteClass(form) {
				await this.$store.dispatch('deleteClass', form)
					.then((res) => {
                        this.getClassList()
                        this.getOverview()
						this.$swal.fire('Success', res.message, 'success')
					})
					.catch((err)=> {
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
            async outOfClass(classId) {
                this.$swal.fire({
                    title: 'Apakah anda yakin?',
                    text: "Semua data akan terhapus dan tidak dapat dikembalikan lagi!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ya, saya yakin',
                    cancelButtonText: 'Tidak'
                }).then((result) => {
                    if (result.value) {
                        let form = {
                            class_id: classId
                        }
                        this.deleteClass(form)
                    }
                })
            }
        },
        async created() {
            if (!this.isAdmin && !this.isTutor) {
                this.$router.push({ name: 'dashboard' })
            }
            await this.getClassList()
            await this.getOverview()
            EventBus.$on('hideJoinClassModal', (val) => {
                if (val) {
					this.hideJoinClassModal()
                }
            })
            EventBus.$on('showJoinClassModal', (val) => {
                if (val) {
					this.showJoinClassModal()
                }
            })
        }
    }
</script>
<style lang="css" scoped>
.table td {
    padding-top: unset;
    padding-bottom: unset;
    vertical-align: unset;
}
</style>